import React from 'react'
import { css, StyleSheet } from 'aphrodite'
import { AppTheme } from '../../../../styles/AppTheme'
import { chatbotNodeIcon } from './ChatbotNodeHeader'
import { NODE_PALETTE } from './chatbotGraph'

export function ChatbotEmptyStart(props) {
  const onAddType = props.onAddType
  const items = (props.palette || NODE_PALETTE || []).filter(item => item.start)
  return (
    <div className={css(Styles.wrap)}>
      <div className={css(Styles.cluster)}>
        <div className={css(Styles.title)}>How should this chatbot start?</div>
        <div className={css(Styles.actions)}>
          {items.map(item => (
            <button
              key={item.type}
              type='button'
              className={css(Styles.card)}
              onClick={() => onAddType && onAddType(item.type)}
            >
              <span className={css(Styles.iconTile)}>
                <i className={'material-icons-outlined ' + css(Styles.icon)}>{chatbotNodeIcon(item.type)}</i>
              </span>
              <span className={css(Styles.cardTitle)}>{item.label}</span>
              {item.description ? (
                <span className={css(Styles.cardDesc)}>{item.description}</span>
              ) : null}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

const Styles = StyleSheet.create({
  wrap: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    boxSizing: 'border-box',
    padding: 24,
  },
  cluster: {
    pointerEvents: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 20,
    maxWidth: '100%',
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: '#222222',
    textAlign: 'center',
    lineHeight: '28px',
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 20,
  },
  card: {
    width: 280,
    padding: 20,
    borderRadius: AppTheme.borderRadius,
    border: '1px solid ' + AppTheme.borderColor,
    backgroundColor: AppTheme.secondaryBg,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
    gap: 10,
    boxSizing: 'border-box',
    ':hover': {
      borderColor: AppTheme.primaryColor,
    },
  },
  iconTile: {
    width: 44,
    height: 44,
    borderRadius: 8,
    backgroundColor: '#e7ffdb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    fontSize: 24,
    color: '#111b21',
  },
  cardTitle: {
    fontSize: 15,
    fontWeight: 600,
    color: '#222222',
    lineHeight: '22px',
  },
  cardDesc: {
    fontSize: 13,
    fontWeight: 400,
    color: '#6B7280',
    lineHeight: '20px',
  },
})
